<template>
  <div class="dropdown d-flex align-items-left">
    <b-dropdown id="perfil" variant="light" class="ml-auto">
      <template #button-content> <b-icon icon="person-fill" scale="1.1" /> {{ usuario.email }} </template>

      <b-dropdown-item v-if="getAcesso('CLIENTE')">
        <b-dropdown-item-button :variant="getClienteLoad == true ? 'success' : ''" @click="carregarClientes()">
          <b-icon icon="briefcase" /> Lista de Clientes
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-item v-if="getAcesso('COMPRA')">
        <b-dropdown-item-button :variant="getFornecedorLoad == true ? 'success' : ''" @click="carregarFornecedores()">
          <b-icon icon="briefcase-fill" /> Lista de Fornecedores
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item v-if="getAcesso('ARMAZEM')">
        <b-dropdown-item-button :variant="loadedArmazem == true ? 'success' : ''" @click="carregarArmazem()">
          <b-icon icon="building" /> Armazém
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item v-if="getAcesso('TRANSPORTE')">
        <b-dropdown-item-button :variant="getVeiculoLoad == true ? 'success' : ''" @click="carregarVeiculos()">
          <b-icon icon="truck" /> Transporte
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item v-if="getAcesso('IMAGEM')">
        <b-dropdown-item-button :variant="getImagemLoad == true ? 'success' : ''" @click="carregarImagens()">
          <b-icon icon="image" /> Banco de Imagens
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-item v-if="getAcesso('EQUIPAMENTO')" >
        <b-dropdown-item-button :variant="getEquipamentoLoad == true ? 'success' : ''" @click="carregarEquipamentos()">
          <b-icon icon="tools" /> Lista de Equipamentos
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-item v-if="getAcesso('INSPECAO')" >
        <b-dropdown-item-button :variant="loadedInspecao == true ? 'success' : ''" @click="carregarInspecao()">
          <b-icon icon="search" /> Inspeção
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item v-if="getAcesso('EQUIPE')" >
        <b-dropdown-item-button :variant="getEquipeLoad == true ? 'success' : ''" @click="carregarEquipes()">
          <b-icon icon="person-lines-fill" /> Controle de Equipes
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item v-if="getAcesso('SERVICO')" >
        <b-dropdown-item-button :variant="getAtividadeLoad == true ? 'success' : ''" @click="carregarAtividades()">
          <b-icon icon="wrench" /> Serviços - Atividades
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-item v-if="getAcesso('SERVICO')" >
        <b-dropdown-item-button :variant="getAvulsoLoad == true ? 'success' : ''" @click="carregarAvulsos()">
          <b-icon icon="screwdriver" /> Serviços - Avulsos
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item v-if="getAcesso('FINANCEIRO')" >
        <b-dropdown-item-button :variant="loadedFinanceiro == true ? 'success' : ''" @click="carregarFinanceiro()">
          <b-icon icon="graph-up" /> Financeiro
        </b-dropdown-item-button>
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item>
        <b-dropdown-item-button @click="logout()">
          <div><b-icon icon="x-circle-fill" class="mr-2" variant="warning" /> Logout</div>
        </b-dropdown-item-button>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useClienteStore } from "@/stores/ClienteStore";
import { useFornecedorStore } from "@/stores/FornecedorStore";
import { useEntradaSaidaStore } from "@/stores/EntradaSaidaStore";
import { useArmazemStore } from "@/stores/ArmazemStore";
import { usePrioridadeStore } from "@/stores/PrioridadeStore";
import { useVeiculoStore } from "@/stores/VeiculoStore";
import { useImagemStore } from "@/stores/ImagemStore";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import { useEquipeStore } from "@/stores/EquipeStore";
import { useAtividadeStore } from "@/stores/AtividadeStore";
import { useAvulsoStore } from "@/stores/AvulsoStore";
import { useConsumivelStore } from "@/stores/ConsumivelStore";
import { useDocumentoStore } from "@/stores/DocumentoStore";
import { useInstrumentoStore } from "@/stores/InstrumentoStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { useTemplateStore } from "@/stores/TemplateStore";
import { useProdutoStore } from "@/stores/ProdutoStore";
import { useOrcamentoStore } from "@/stores/OrcamentoStore";
import { useFaturamentoStore } from "@/stores/FaturamentoStore";
import { useLaudoTecnicoStore } from "@/stores/LaudoTecnicoStore";
import Notificacao from "@/models/Notificacao";
import Security from "@/tools/Security";

export default {
  name: "StoreLoader",

  data() {
    return {
      loadedArmazem: false,
      loadedInspecao: false,
      loadedFinanceiro: false,
      seguranca: new Security(),
    };
  },

  mounted: function () {
    this.$nextTick(function () {
      //Verifica o carregamento do armazem
      if (this.getPrioridadeLoad) {
        this.loadedArmazem = true;
      } else {
        this.loadedArmazem = false;
      }
      //Verifica o carregamento da inspeção
      if (
        this.getDocumentoLoad &&
        this.getInstrumentoLoad &&
        this.getProfissionalLoad &&
        this.getConsumivelLoad &&
        this.getTemplateLoad
      ) {
        this.loadedInspecao = true;
      } else {
        this.loadedInspecao = false;
      }
      //Verifica o carregamento da inspeção
      if (this.getOrcamentoLoad && this.getProdutoLoad && this.getFaturamentoLoad) {
        this.loadedFinanceiro = true;
      } else {
        this.loadedFinanceiro = false;
      }
    });
  },

  methods: {
    carregarClientes() {
      this.clienteStore.LISTAR_CLIENTES().then(() => {
        this.lidarComSucesso("Clientes foram carregados com sucesso!");
      });
    },

    carregarFornecedores() {
      this.fornecedorStore.LISTAR_FORNECEDORES().then(() => {
        this.lidarComSucesso("Fornecedores foram carregados com sucesso!");
      });
    },

    carregarArmazem() {
      this.entradaSaidaStore.LISTAR_ENTRADAS();
      this.entradaSaidaStore.LISTAR_SAIDAS();
      this.armazemStore.LISTAR_ARMAZENADOS();
      this.prioridadeStore.LISTAR_PRIORIDADES().then(() => {
        this.lidarComSucesso("Todos os itens do armazém foram carregados com sucesso!");
        this.loadedArmazem = true;
      });
    },

    carregarVeiculos() {
      this.veiculoStore.LISTAR_VEICULOS().then(() => {
        this.lidarComSucesso("Todos os itens dos transportes foram carregados com sucesso!");
      });
    },

    carregarAtividades() {
      this.atividadeStore.LISTAR_ATIVIDADES().then(() => {
        this.lidarComSucesso("Atividades das equipes foram carregados com sucesso!");
      });
    },

    carregarAvulsos() {
      this.avulsoStore.LISTAR_AVULSOS().then(() => {
        this.lidarComSucesso("Serviços avulsos foram carregados com sucesso!");
      });
    },

    carregarImagens() {
      this.imagemStore.LISTAR_IMAGENS().then(() => {
        this.lidarComSucesso("O banco de imagem foi carregado com sucesso!");
      });
    },

    carregarEquipamentos() {
      this.equipamentoStore.LISTAR_EQUIPAMENTOS().then(() => {
        this.lidarComSucesso("Os equipamentos foram carregados com sucesso!");
      });
    },

    carregarEquipes() {
      this.equipeStore.LISTAR_EQUIPES().then(() => {
        this.lidarComSucesso("As equipes foram carregadas com sucesso!");
      });
    },

    carregarInspecao() {
      this.consumivelStore.LISTAR_CONSUMIVEIS();
      this.documentoStore.LISTAR_DOCUMENTOS();
      this.instrumentoStore.LISTAR_INSTRUMENTOS();
      this.templateStore.LISTAR_CERTIFICADOS();
      this.templateStore.LISTAR_INSPECOES();
      this.templateStore.LISTAR_MEDICOES();
      this.templateStore.LISTAR_CHECKLIST();
      this.templateStore.LISTAR_PLANO();
      this.laudoTecnicoStore.LISTAR_LAUDOSTECNICOS();
      this.profissionalStore.LISTAR_PROFISSIONAIS().then(() => {
        this.lidarComSucesso("Todos os itens para a inspeção foram carregados com sucesso!");
        this.loadedInspecao = true;
      });
    },

    carregarFinanceiro() {
      this.carregarClientes();
      setTimeout(() => {
        this.orcamentoStore.LISTAR_ORCAMENTOS();
        this.faturamentoStore.LISTAR_FATURAMENTOS();
        this.produtoStore.LISTAR_PRODUTOS().then(() => {
          this.lidarComSucesso("Todos os itens para a financeiro foram carregados com sucesso!");
          this.loadedFinanceiro = true;
        });
      }, 2500);
    },

    lidarComSucesso(mensagem) {
      this.store.NOTIFICAR(new Notificacao(mensagem, "Excelente!", "success"));
    },

    logout() {
      this.store.EFETUAR_LOGOUT();
      this.$router.push({ path: "/login" });
    },

    getAcesso(modulo) {
      return this.seguranca.access(this.usuario, modulo);
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();
    const fornecedorStore = useFornecedorStore();
    const entradaSaidaStore = useEntradaSaidaStore();
    const armazemStore = useArmazemStore();
    const prioridadeStore = usePrioridadeStore();
    const veiculoStore = useVeiculoStore();
    const imagemStore = useImagemStore();
    const equipamentoStore = useEquipamentoStore();
    const equipeStore = useEquipeStore();
    const atividadeStore = useAtividadeStore();
    const avulsoStore = useAvulsoStore();
    const consumivelStore = useConsumivelStore();
    const documentoStore = useDocumentoStore();
    const instrumentoStore = useInstrumentoStore();
    const profissionalStore = useProfissionalStore();
    const templateStore = useTemplateStore();
    const produtoStore = useProdutoStore();
    const orcamentoStore = useOrcamentoStore();
    const faturamentoStore = useFaturamentoStore();
    const laudoTecnicoStore = useLaudoTecnicoStore();

    //Constantes para display do loader
    const { getClienteLoad } = storeToRefs(clienteStore);
    const { getFornecedorLoad } = storeToRefs(fornecedorStore);
    const { getEntradaSaidaLoad } = storeToRefs(entradaSaidaStore);
    const { getFilterArmazenados } = storeToRefs(armazemStore);
    const { getEquipamentoLoad } = storeToRefs(equipamentoStore);
    const { getEquipeLoad } = storeToRefs(equipeStore);
    const { getPrioridadeLoad } = storeToRefs(prioridadeStore);
    const { getAtividadeLoad } = storeToRefs(atividadeStore);
    const { getAvulsoLoad } = storeToRefs(avulsoStore);
    const { getVeiculoLoad } = storeToRefs(veiculoStore);
    const { getImagemLoad } = storeToRefs(imagemStore);
    const { getConsumivelLoad } = storeToRefs(consumivelStore);
    const { getDocumentoLoad } = storeToRefs(documentoStore);
    const { getInstrumentoLoad } = storeToRefs(instrumentoStore);
    const { getProfissionalLoad } = storeToRefs(profissionalStore);
    const { getTemplateLoad } = storeToRefs(templateStore);
    const { getOrcamentoLoad } = storeToRefs(orcamentoStore);
    const { getProdutoLoad } = storeToRefs(produtoStore);
    const { getFaturamentoLoad } = storeToRefs(faturamentoStore);
    const { getLaudoLoad } = storeToRefs(laudoTecnicoStore);

    return {
      store,
      clienteStore,
      fornecedorStore,
      entradaSaidaStore,
      armazemStore,
      prioridadeStore,
      equipamentoStore,
      equipeStore,
      atividadeStore,
      avulsoStore,
      veiculoStore,
      imagemStore,
      profissionalStore,
      instrumentoStore,
      documentoStore,
      consumivelStore,
      templateStore,
      produtoStore,
      orcamentoStore,
      faturamentoStore,
      laudoTecnicoStore,
      usuario: store.getUser,
      //refs to status
      getClienteLoad,
      getFornecedorLoad,
      getEntradaSaidaLoad,
      getFilterArmazenados,
      getPrioridadeLoad,
      getEquipamentoLoad,
      getEquipeLoad,
      getAtividadeLoad,
      getAvulsoLoad,
      getVeiculoLoad,
      getImagemLoad,
      getOrcamentoLoad,
      getProdutoLoad,
      getConsumivelLoad,
      getDocumentoLoad,
      getInstrumentoLoad,
      getProfissionalLoad,
      getTemplateLoad,
      getFaturamentoLoad,
      getLaudoLoad,
    };
  },
};
</script>

<style lang="scss" scoped></style>
